import { render } from "./AtuarSC.vue?vue&type=template&id=3e04c47c&scoped=true"
import script from "./AtuarSC.vue?vue&type=script&lang=js"
export * from "./AtuarSC.vue?vue&type=script&lang=js"

import "./AtuarSC.vue?vue&type=style&index=0&id=3e04c47c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e04c47c"]])

export default __exports__